import { Decimal } from 'decimal.js';
export function hasAtMostDecimalPlaces(value, places) {
    return new Decimal(value).decimalPlaces() <= places;
}
//# sourceMappingURL=has-at-most-decimal-places.js.map